<template>
    <div>
        <div class="items-kit-accessory-btn">
            <button class="items-kit-accessory-action-chip" @click="handleBack">
                <i class="fa-solid fa-circle-arrow-left"></i>
                <span>Voltar para Produtos</span>
            </button>
        </div>
        <div class="items-kit-accessory-items">
            <div>
                <div v-if="kitOrAcessory == 'kit'" class="items-kit-accessory-avatar">
                    <i class="fa-solid fa-boxes-stacked"></i>
                    <span class="items-kit-accessory-title">{{ itemRent.kitRentName }}</span>
                </div>
                <div v-else class="items-kit-accessory-avatar">
                    <i class="fas fa-toolbox"></i>
                    <span class="items-kit-accessory-title">{{ itemRent.productFullName }}</span>
                </div>
            </div>

            <Loading type="line" v-if="loading" :center="false" />

            <draggable v-else v-model="items" tag="div" :group="{ name: 'products', pull: true, put: true }"
                item-key="id" @change="onDragChange" @end="onDragEnd">
                <div v-for="item in items" :key="item.id">
                    <ItemsRentRow :showKitOrAccessory="false" :rent="rent" :item="item" :operational="operational"
                        :totalRecords="items.length" />
                </div>
            </draggable>

            <div v-if="!items.length && !loading">
                <span class="items-list-empty">Nenhum registro encontrado!</span>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import ItemsRentRow from "./ItemsRentRow.vue";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "ItemKitList",
    props: {
        operational: { type: Boolean, default: false },
        itemRent: { type: Object, default: false },
        rent: { type: Object, default: () => ({}) },
        kitOrAcessory: String,
        back: Function
    },
    components: {
        draggable,
        ItemsRentRow,
        Loading
    },
    data() {
        return {
            urlGetAll: "/api/v1/rental/items-rent/get-all-kit-or-accessory",
            urlReorderItemsApi: "/api/v1/rental/items-rent/reorder-items",
            items: [],
            loading: true
        };
    },
    mounted() {
        this.getAll();
    },
    computed: {
        ...mapGetters("generic", ["event"])
    },
    methods: {
        ...mapActions("generic", ["getApi", "putApi"]),
        handleBack() {
            this.back && this.back();
        },
        getAll() {
            const itemsRentId = this.itemRent.kitId
                ? ""
                : (this.itemRent.itemsRentId || this.itemRent.id);

            const params = {
                url: this.urlGetAll,
                obj: {
                    rentId: this.itemRent.rentId,
                    kitId: this.itemRent.kitId,
                    itemsRentId
                }
            };
            this.getApi(params).then(response => {
                this.items = response.content;
                this.loading = false;
            });
        },
        reorderItems(items) {
            let params = { url: this.urlReorderItemsApi, obj: items, notNotifyToast: true };
            this.putApi(params).then(() => { });
        },
        onDragChange(event) {

        },
        onDragEnd(event) {
            let items = [];
            let seq = 0;
            this.items.forEach(item => {
                item.order = seq;
                items.push(item);
                seq++;
            });
            this.reorderItems(items);
        }
    },
    watch: {
        event: {
            handler({ name }) {
                if (["itemRentUpdate", "updateTotalizationRent", "actionsUpdated"].includes(name)) {
                    this.getAll();
                }
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.items-kit-accessory-btn {
    margin-top: 20px;
    margin-left: 5px;
    margin-bottom: 20px;
}

.items-kit-accessory-action-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 12px;
    border-radius: 9999px;
    border: none;
    background: #4bb4e2;
    color: #fff;
    font-size: 13px;
    line-height: 1;
    cursor: pointer;
}

.items-kit-accessory-items {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    overflow: hidden;
    background: transparent;
}

.items-kit-accessory-avatar {
    height: 50px;
    width: 100%;
    padding-top: 15px;
    padding-left: 10px;
    border: 0px solid #e5e7eb;
    background-color: #F6F6F8;
    color: #6b7280;
    font-size: 16px;
    line-height: 1;
    margin-right: 20px;
    margin-bottom: 10px;
}

.items-kit-accessory-title {
    font-weight: 500;
    font-size: 14px;
    margin-left: 10px;
}

.items-list-empty {
    padding: 10px;
}
</style>
